import { useState, useEffect } from 'react';
import { AlertCircle } from 'lucide-react';
import HorseCard from './HorseCard';

export default function HorseCare({ horses, user, API_URL, isDemoMode, setError, setSuccess }) {
  const [expiringDocuments, setExpiringDocuments] = useState([]);
  const [expandedHorseId, setExpandedHorseId] = useState(null);

  useEffect(() => {
    if (horses.length > 0) {
      loadExpiringDocuments();
    }
  }, [horses]);

  const loadExpiringDocuments = async () => {
    try {
      const response = await fetch(`${API_URL}/documents/expiring`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        setExpiringDocuments(data);
      }
    } catch (err) {
      console.error('Failed to load expiring documents:', err);
    }
  };

  const toggleHorse = (horseId) => {
    setExpandedHorseId(expandedHorseId === horseId ? null : horseId);
  };

  return (
    <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: '700', marginBottom: '10px', color: '#1f2937' }}>
        Horse Care
      </h1>
      <p style={{ fontSize: '1rem', color: '#6b7280', marginBottom: '30px' }}>
        Daily care checklist for all your horses
      </p>

      {/* Expiring Documents Alert */}
      {expiringDocuments.length > 0 && (
        <div style={{
          background: '#fef3c7',
          border: '1px solid #f59e0b',
          borderRadius: '8px',
          padding: '16px',
          marginBottom: '24px',
          display: 'flex',
          alignItems: 'start',
          gap: '12px'
        }}>
          <AlertCircle size={24} style={{ color: '#f59e0b', flexShrink: 0, marginTop: '2px' }} />
          <div>
            <div style={{ fontWeight: '600', color: '#92400e', marginBottom: '8px' }}>
              Documents Expiring Soon
            </div>
            {expiringDocuments.map(doc => (
              <div key={doc.id} style={{ fontSize: '0.875rem', color: '#92400e', marginBottom: '4px' }}>
                • {doc.horse_name}: {doc.document_type.replace('_', ' ')} expires {new Date(doc.expiration_date).toLocaleDateString()}
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Horse Cards */}
      {horses.length === 0 ? (
        <div style={{
          textAlign: 'center',
          padding: '60px 20px',
          background: '#f9fafb',
          borderRadius: '8px',
          color: '#6b7280'
        }}>
          <div style={{ fontSize: '1.125rem', marginBottom: '8px' }}>No horses yet</div>
          <div style={{ fontSize: '0.875rem' }}>Add a horse from the Dashboard to get started</div>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {horses.map(horse => (
            <HorseCard
              key={horse.id}
              horse={horse}
              isExpanded={expandedHorseId === horse.id}
              onToggle={() => toggleHorse(horse.id)}
              API_URL={API_URL}
              isDemoMode={isDemoMode}
              setError={setError}
              setSuccess={setSuccess}
              onDocumentChange={loadExpiringDocuments}
            />
          ))}
        </div>
      )}
    </div>
  );
}
